import type { SidePanel } from '../appSlice'
import { useComposerStore } from '../hooks/useComposerStore'

export const useIsPreviewMode = (): boolean => {
  return useComposerStore((state) => state.previewMode)
}

export const useComposerMode = (): 'create' | 'edit' | 'duplicate' => {
  return useComposerStore((state) => state.mode)
}

export const useIsDraftMode = (): boolean => {
  return useComposerStore((state) => state.draftMode)
}

export const useActiveSidePanel = (): SidePanel | null => {
  return useComposerStore((state) => state.activeSidePanel)
}

export const useSetActiveSidePanel = (): ((
  sidePanel: SidePanel | null,
) => void) => {
  return useComposerStore((state) => state.setActiveSidePanel)
}

export const useToggleSidePanel = (): ((sidePanel: SidePanel) => void) => {
  const activeSidePanel = useActiveSidePanel()
  const setActiveSidePanel = useSetActiveSidePanel()

  return (sidePanel: SidePanel) => {
    setActiveSidePanel(activeSidePanel === sidePanel ? null : sidePanel)
  }
}

export const useShouldPrefetchTemplates = (): boolean => {
  return useComposerStore((state) => state.shouldPrefetchTemplates)
}

export const usePrefetchTemplates = (): (() => void) => {
  return useComposerStore((state) => state.prefetchTemplates)
}

export const useCorrelationId = (): string => {
  return useComposerStore((state) => state.correlationId)
}

export const usePrefillAiPrompt = (): string | null | undefined => {
  return useComposerStore((state) => state.prefillAiPrompt)
}

export const useComposerTransitionFinished = (): boolean => {
  return useComposerStore((state) => state.composerTransitionFinished)
}

export const useSetComposerTransitionFinished = (): (() => void) => {
  return useComposerStore((state) => state.setComposerTransitionFinished)
}
